import { FC } from "react";
import LookNameToShellNameSvg from "../../public/icons/LookName_to_ShellName.svg";
import { IconProps, useAddMissingAntIconClass } from "../hooks/use-add-missing-ant-icon-class";

export const ApplyLookNameToShellNameIcon: FC<IconProps> = (iconProps) =>
  <span role="img" {...useAddMissingAntIconClass(iconProps)}><LookNameToShellNameSvg/></span>;
